import { createGlobalState } from "react-hooks-global-state";
export var initialState = {
    pendingTransactions: [],
    showConnectWallet: false,
    gasPrice: "",
    desktopView: "grid",
    airdropInfo: undefined,
    vaultPositionModal: {
        show: false,
        vaultVersion: "v1",
    },
    notificationLastReadTimestamp: undefined,
};
export var useGlobalState = createGlobalState(initialState).useGlobalState;
//# sourceMappingURL=store.js.map